module.exports = __webpack_public_path__ + "static/img/weather_030.2933c4c7.svg";